import React from 'react'
import propTypes from 'prop-types'
import { Link } from 'react-router-dom'
import get from 'lodash/get'
import { formatDateTime } from '@atheneum/api/dist/lib'

const logPropTypes = { log: propTypes.object.isRequired }

export const ProjectCreateTemplate = ({ log }) => (
  <div>
    Employee{' '}
    <Link to={get(log, 'links.user.to', '')}>
      {get(log, 'links.user.text', 'MISSING')}
    </Link>{' '}
    created project{' '}
    <Link to={get(log, 'links.project.to', '')}>
      {get(log, 'links.project.text', 'MISSING')}
    </Link>
  </div>
)
ProjectCreateTemplate.propTypes = logPropTypes

export const ProjectUpdateTemplate = ({ log }) => (
  <div>
    Employee{' '}
    <Link to={get(log, 'links.user.to', '')}>
      {get(log, 'links.user.text', 'MISSING')}
    </Link>{' '}
    updated project{' '}
    <Link to={get(log, 'links.project.to', '')}>
      {get(log, 'links.project.text', 'MISSING')}
    </Link>
  </div>
)
ProjectUpdateTemplate.propTypes = logPropTypes

export const EPLCreateTemplate = ({ log }) => (
  <div>
    Employee{' '}
    <Link to={get(log, 'links.user.to', '')}>
      {get(log, 'links.user.text', 'MISSING')}
    </Link>{' '}
    added expert{' '}
    <Link to={get(log, 'links.expert.to', '')}>
      {get(log, 'links.expert.text', 'MISSING')}
    </Link>{' '}
    to project{' '}
    <Link to={get(log, 'links.project.to', '')}>
      {get(log, 'links.project.text', 'MISSING')}
    </Link>
  </div>
)
EPLCreateTemplate.propTypes = logPropTypes

export const UserLoginTemplate = ({ log }) => (
  <div>
    User{' '}
    <Link to={get(log, 'links.user.to', '')}>
      {get(log, 'links.user.text', 'MISSING')}
    </Link>{' '}
    has logged in
  </div>
)
UserLoginTemplate.propTypes = logPropTypes

export const FeeCreateLog = ({ log }) => {
  return (
    <div>
      Employee{' '}
      <Link to={get(log, 'links.user.to', '')}>
        {get(log, 'links.user.text', 'MISSING')}
      </Link>{' '}
      created a{' '}
      <Link to={get(log, 'links.fee.to', '')}>
        {get(log, 'links.fee.text', 'MISSING')}
      </Link>{' '}
      {log.links.expert && (
        <span>
          for expert{' '}
          <Link to={get(log, 'links.expert.to', '')}>
            {get(log, 'links.expert.text', 'MISSING')}
          </Link>
        </span>
      )}
      on project{' '}
      <Link to={get(log, 'links.project.to', '')}>
        {get(log, 'links.project.text', 'MISSING')}
      </Link>
    </div>
  )
}
FeeCreateLog.propTypes = logPropTypes

export const FeeUpdateLog = ({ log }) => {
  return (
    <div>
      Employee{' '}
      <Link to={get(log, 'links.user.to', '')}>
        {get(log, 'links.user.text', 'MISSING')}
      </Link>{' '}
      updated a{' '}
      <Link to={get(log, 'links.fee.to', '')}>
        {get(log, 'links.fee.text', 'MISSING')}
      </Link>{' '}
      {log.links.expert && (
        <span>
          for expert{' '}
          <Link to={get(log, 'links.expert.to', '')}>
            {get(log, 'links.expert.text', 'MISSING')}
          </Link>{' '}
        </span>
      )}
      on project{' '}
      <Link to={get(log, 'links.project.to', '')}>
        {get(log, 'links.project.text', 'MISSING')}
      </Link>
    </div>
  )
}
FeeUpdateLog.propTypes = logPropTypes

export const ContractUpdateTemplate = ({ log }) => (
  <div>
    Employee{' '}
    <Link to={get(log, 'links.user.to', '')}>
      {get(log, 'links.user.text', 'MISSING')}
    </Link>{' '}
    edited contract{' '}
    <Link to={get(log, 'links.contract.to', '')}>
      {get(log, 'links.contract.text', 'MISSING')}
    </Link>{' '}
    under{' '}
    <Link to={get(log, 'links.parentAccount.to', '')}>
      {get(log, 'links.parentAccount.text', 'MISSING')}
    </Link>
  </div>
)
ContractUpdateTemplate.propTypes = logPropTypes

export const ExpertCreateTemplate = ({ log }) => (
  <div>
    Employee{' '}
    <Link to={get(log, 'links.user.to', '')}>
      {get(log, 'links.user.text', 'MISSING')}
    </Link>{' '}
    created profile for expert{' '}
    <Link to={get(log, 'links.expert.to', '')}>
      {get(log, 'links.expert.text', 'MISSING')}
    </Link>
  </div>
)
ExpertCreateTemplate.propTypes = logPropTypes

export const ClientCreateTemplate = ({ log }) => (
  <div>
    Employee{' '}
    <Link to={get(log, 'links.user.to', '')}>
      {get(log, 'links.user.text', 'MISSING')}
    </Link>{' '}
    created profile for client{' '}
    <Link to={get(log, 'links.client.to', '')}>
      {get(log, 'links.client.text', 'MISSING')}
    </Link>
  </div>
)
ClientCreateTemplate.propTypes = logPropTypes

export const PasswordChangedTemplate = ({ log }) => (
  <div>
    User{' '}
    <Link to={get(log, 'links.user.to', '')}>
      {get(log, 'links.user.text', 'MISSING')}
    </Link>{' '}
    retrived password
  </div>
)
PasswordChangedTemplate.propTypes = logPropTypes

export const ExpertUpdateOtherTemplate = ({ log }) => (
  <div>
    Employee{' '}
    <Link to={get(log, 'links.user.to', '')}>
      {get(log, 'links.user.text', 'MISSING')}
    </Link>{' '}
    updated profile for expert{' '}
    <Link to={get(log, 'links.expert.to', '')}>
      {get(log, 'links.expert.text', 'MISSING')}
    </Link>
  </div>
)

ExpertUpdateOtherTemplate.propTypes = logPropTypes

export const ExpertSetComplianceSignedTemplate = ({ log }) => (
  <div>
    Employee{' '}
    <Link to={get(log, 'links.user.to', '')}>
      {get(log, 'links.user.text', 'MISSING')}
    </Link>{' '}
    signed compliance for expert{' '}
    <Link to={get(log, 'links.expert.to', '')}>
      {get(log, 'links.expert.text', 'MISSING')}
    </Link>
  </div>
)

ExpertSetComplianceSignedTemplate.propTypes = logPropTypes

export const CPDCreateTemplate = ({ log }) => {
  return (
    <div>
      <Link to={get(log, 'links.user.to', '')}>
        {get(log, 'links.user.text', 'MISSING')}
      </Link>{' '}
      created new consultation payment details
    </div>
  )
}
CPDCreateTemplate.propTypes = logPropTypes

export const EmployeeUpdateOtherTemplate = ({ log }) => {
  return (
    <div>
      <Link to={get(log, 'links.user.to', '')}>
        {get(log, 'links.user.text', 'MISSING')}
      </Link>{' '}
      updated profile of employee{' '}
      <Link to={get(log, 'links.employee.to', '')}>
        {get(log, 'links.employee.text', 'MISSING')}
      </Link>
    </div>
  )
}
EmployeeUpdateOtherTemplate.propTypes = logPropTypes

export const EmployeeCreateTemplate = ({ log }) => {
  return (
    <div>
      <Link to={get(log, 'links.user.to', '')}>
        {get(log, 'links.user.text', 'MISSING')}
      </Link>{' '}
      created new employee{' '}
      <Link to={get(log, 'links.employee.to', '')}>
        {get(log, 'links.employee.text', 'MISSING')}
      </Link>
    </div>
  )
}
EmployeeCreateTemplate.propTypes = logPropTypes

export const EmployeeUpdateSelfTemplate = ({ log }) => {
  return (
    <div>
      <Link to={get(log, 'links.user.to', '')}>
        {get(log, 'links.user.text', 'MISSING')}
      </Link>{' '}
      edited their profile.
    </div>
  )
}
EmployeeUpdateSelfTemplate.propTypes = logPropTypes

export const InvoicingEntityCreateTemplate = ({ log }) => {
  return (
    <div>
      <div>
        <ObjectLink type='user' log={log} /> created invoicing entity{' '}
        <ObjectLink type='invoicingEntity' log={log} /> under{' '}
        <ObjectLink type='parentAccount' log={log} />
      </div>
    </div>
  )
}
InvoicingEntityCreateTemplate.propTypes = logPropTypes

export const InvoicingEntityUpdateTemplate = ({ log }) => {
  return (
    <div>
      <ObjectLink type='user' log={log} /> updated invoicing entity{' '}
      <ObjectLink type='invoicingEntity' log={log} /> under{' '}
      <ObjectLink type='parentAccount' log={log} />
    </div>
  )
}
InvoicingEntityUpdateTemplate.propTypes = logPropTypes

export const AccountCreateTemplate = ({ log }) => {
  return (
    <div>
      <ObjectLink to='user' log={log} /> created account{' '}
      <ObjectLink to='account' log={log} /> under{' '}
      <ObjectLink to='parentAccount' log={log} />
    </div>
  )
}
AccountCreateTemplate.propTypes = logPropTypes

export const AccountUpdateTemplate = ({ log }) => {
  return (
    <div>
      <ObjectLink type='user' log={log} /> updated account{' '}
      <ObjectLink type='account' log={log} />
    </div>
  )
}
AccountUpdateTemplate.propTypes = logPropTypes

export const UserSignupTemplate = ({ log }) => {
  return (
    <div>
      Client <ObjectLink type='user' log={log} /> has registred
    </div>
  )
}
UserSignupTemplate.propTypes = logPropTypes

export const ClientUpdateOtherTemplate = ({ log }) => {
  return (
    <div>
      <ObjectLink type='user' log={log} /> has updatet client profile for{' '}
      <ObjectLink type='client' log={log} />
    </div>
  )
}
ClientUpdateOtherTemplate.propTypes = logPropTypes

export const ClientToProjectAvailabilityTemplate = ({ log }) => {
  return (
    <div>
      <ObjectLink type='user' log={log} /> added availability slot on{' '}
      <ObjectLink type='project' log={log} /> for{' '}
      <ObjectLink type='client' log={log} />
    </div>
  )
}
ClientToProjectAvailabilityTemplate.propTypes = logPropTypes

export const ExpertAvailablityToEplCreateTemplate = ({ log }) => {
  return (
    <div>
      <ObjectLink type='user' log={log} /> added availability slot on{' '}
      <ObjectLink type='project' log={log} /> for{' '}
      <ObjectLink type='expert' log={log} />
    </div>
  )
}
ExpertAvailablityToEplCreateTemplate.propTypes = logPropTypes

export const ContractCreateTemplate = ({ log }) => {
  return (
    <div>
      <ObjectLink type='user' log={log} /> created contract{' '}
      <ObjectLink type='contract' log={log} /> under{' '}
      <ObjectLink type='parentAccount' log={log} />
    </div>
  )
}
ContractCreateTemplate.propTypes = logPropTypes

export const EmailConfirmTemplate = ({ log }) => {
  return (
    <div>
      <ObjectLink type='user' log={log} /> confirmed their email account
    </div>
  )
}
EmailConfirmTemplate.propTypes = logPropTypes

export const ExpertCompleteProfile = ({ log }) => {
  return (
    <div>
      <ObjectLink type='user' log={log} /> completed their profile
    </div>
  )
}
ExpertCompleteProfile.propTypes = logPropTypes

export const ExpertUpdateSelfTemplate = ({ log }) => {
  return (
    <div>
      <ObjectLink type='user' log={log} /> edited their profile
    </div>
  )
}
ExpertUpdateSelfTemplate.propTypes = logPropTypes

export const OfficeCreateTemplate = ({ log }) => {
  return (
    <div>
      <ObjectLink type='user' log={log} /> created office account{' '}
      <ObjectLink type='office' log={log} /> under{' '}
      <ObjectLink type='parentAccount' log={log} />
    </div>
  )
}
OfficeCreateTemplate.propTypes = logPropTypes

export const OfficeUpdateTemplate = ({ log }) => {
  return (
    <div>
      <ObjectLink type='user' log={log} /> updated office account{' '}
      <ObjectLink type='office' log={log} /> under{' '}
      <ObjectLink type='parentAccount' log={log} />
    </div>
  )
}
OfficeUpdateTemplate.propTypes = logPropTypes

export const ParentAccountCreateTemplate = ({ log }) => {
  return (
    <div>
      <ObjectLink type='user' log={log} /> created parent account{' '}
      <ObjectLink type='parentAccount' log={log} />
    </div>
  )
}
ParentAccountCreateTemplate.propTypes = logPropTypes

export const ParentAccountUpdateTemplate = ({ log }) => {
  return (
    <div>
      <ObjectLink type='user' log={log} /> updated parent account{' '}
      <ObjectLink type='parentAccount' log={log} />
    </div>
  )
}
ParentAccountUpdateTemplate.propTypes = logPropTypes

export const ExtractEplsEmailSent = ({ log }) => {
  return (
    <div>
      <ObjectLink type='user' log={log} /> has sent an EPL extract to the client
      on {formatDateTime(log.links.email.text)}
    </div>
  )
}

ExtractEplsEmailSent.propTypes = logPropTypes

const ObjectLink = ({ type, log }) => (
  <Link to={get(log, `links.${type}.to`, '')}>
    {get(log, `links.${type}.text`, 'MISSING')}
  </Link>
)
ObjectLink.propTypes = {
  type: propTypes.string.isRequired,
  log: propTypes.object.isRequired
}

export const MissingTemplate = ({ log }) => (
  <div style={{ background: 'red' }}>Missing template for {log.type}</div>
)
MissingTemplate.propTypes = logPropTypes
